import React from 'react';
import BlackButton from '../Utils/BlackButton';
import GrayButton from '../Utils/GrayButton';

const ModalDelete = ({ isOpen, onClose, onConfirm, productName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <svg 
                className="w-8 h-8 text-red-500" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z" 
                />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-medium text-gray-900">
                Eliminar Producto
              </h3>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-gray-700">
              ¿Estás seguro de que deseas eliminar el producto{' '}
              <span className="font-semibold">"{productName}"</span>?
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Esta acción no se puede deshacer.
            </p>
          </div>

          <div className="flex space-x-3">
            <GrayButton onClick={onClose} className="flex-1">
              Cancelar
            </GrayButton>
            <BlackButton 
              onClick={onConfirm} 
              className="flex-1"
              style={{ backgroundColor: '#ef4444' }}
            >
              Eliminar
            </BlackButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDelete;
